<template>
    <div :class="{'noClick': loading}" :disabled="loading">
        <!-- place the gsi script inside the component  to render the login button when routing -->
        <component is="script" src="https://accounts.google.com/gsi/client" async />
        <div id="g_id_onload"
            :data-client_id="$store.state.Client_ID"
            data-context="signin"
            data-ux_mode="popup"
            data-callback="handleCredentialResponse"
            data-auto_prompt="false">
        </div>

        <div class="g_id_signin"
            data-type="standard"
            data-shape="rectangular"
            data-theme="outline"
            data-text="signin_with"
            data-size="large"
            data-logo_alignment="left">
        </div>
    </div>
</template>
      
<script>
    import User from '@/services/User.service';

    export default {
    name: 'googleOAuth',
    props:['setloading','loading','close'],
    components: {
        
    },
    async mounted(){
        window.handleCredentialResponse = (response) => {
            this.verifyOauthToken(response);
        }
    },
    data () {
        return {
            item: {},
        }
    },
    methods: {
        async verifyOauthToken(response) {
            this.setloading(true);
            const  res = await this.$store.state.axiosInstance.post(this.$store.state.API_ENDPOINT+'/v1/oauth-login',{...response});
            this.setloading(false);
            if(res.data&&res.data.success){
            User.storeToken(res.data.data.token);
            this.Item={};
            this.close();
            this.$forceUpdate();
            this.$router.go(0);
            }else if(res.data&&res.data.message){
                this.$store.state.toastr.open({timeOut:5000, type:"error", 
                title:'Login Failed ', text: res.data.message || 'Login Failed'});
            }
        },
    }
    }
    </script>

    <style scoped>

    .noClick {
        pointer-events: none;
    }
</style>
      
    




// WEBPACK FOOTER //
// src/components/LogInPopUp/googleOAuth.vue